export default __webpack_public_path__ + "static/media/banner-image.33fab4cb.jpeg";